import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';

export const DEFAULT_DISCOUNT_REMOVED_MESSAGE =
  'This discount will be removed as your order no longer meets the requirements';

export type OrderEditingConfigForm = {
  state: FormControl<OrderEditing.State>;
  template: FormGroup<{
    edits: FormGroup<{
      isDisplayed: FormControl<boolean>;
      product: FormGroup<{
        variant: FormControl<boolean>;
        quantity: FormControl<boolean>;
        addProducts: FormControl<boolean>;
        orderNote: FormControl<boolean>;
        cancelOrder: FormControl<boolean>;
        changeFulfillmentLocation: FormControl<boolean>;
        outOfStockProducts: FormControl<boolean>;
        discountCode: FormControl<boolean>;
      }>;
      customerDetails: FormGroup<{
        shippingAddress: FormControl<boolean>;
        allowEditPhone: FormControl<boolean>;
        allowEditEmail: FormControl<boolean>;
        allowChangingDestinationCountry: FormControl<boolean>;
        allowTaxRecalculation: FormControl<boolean>;
      }>;
      rulesEnabled: FormControl<boolean>;
      rules: FormArray<any>;
    }>;
    repricing: FormGroup<{
      itemRemovalAdjustment: FormControl<boolean>;
      itemRemovalRefundHandlingType: FormControl<OrderEditing.RefundHandlingType>;
      unpaidChangesHandlingType: FormControl<OrderEditing.UnpaidChangesHandlingType>;
      taxAdjustments: FormGroup<{
        enabled: FormControl<boolean>;
        type: FormControl<OrderEditing.TaxAdjustmentType>;
      }>;
    }>;
    periods: FormGroup<{
      type: FormControl<OrderEditing.PeriodType>;
      value: FormControl<number>;
      extendOnNonBusinessDays: FormControl<boolean>;
    }>;
    settings: FormGroup<{
      useShopifyFlows: FormControl<boolean>;
      fulfillmentHoldReleaseMode: FormControl<OrderEditing.FulfillmentHoldReleaseMode>;
      shippingRecalculation: FormGroup<{
        enabled: FormControl<boolean>;
        recalculationMode: FormControl<OrderEditing.ShippingRecalculationMode>;
        customerExperience: FormControl<OrderEditing.ShippingCustomerExperience>;
        allowDowngrades: FormControl<boolean>;
        downgradeRefundHandlingType: FormControl<OrderEditing.RefundHandlingType>;
        eligibleMethodsMode: FormControl<OrderEditing.ShippingEligibleMethodsMode>;
        methodNames: FormControl<string[]>;
        minimumChargeThreshold: FormControl<number>;
      }>;
      discountCodes: FormGroup<{
        recalculateEligibility: FormControl<boolean>;
        discountRemovedMessage: FormControl<string>;
      }>;
    }>;
    addressValidation: FormGroup<{
      enabled: FormControl<boolean>;
    }>;
  }>;
};

export const OrderEditingMetricsConfigOld: Record<string, OrderEditingMetric> = {
  impressions: {
    label: 'Impressions',
    value: 0,
    suffix: '',
    prefix: '',
  },
  editsCompleted: {
    label: 'Edits Completed',
    value: 0,
    suffix: '',
    prefix: '',
  },
  netRevenueChange: {
    label: 'Net Revenue Change',
    value: 0,
    suffix: '',
    prefix: '$',
  },
  editEngagementRate: {
    label: 'Edit Engagement rate',
    value: 0,
    suffix: '%',
    prefix: '',
  },
};

export const OrderEditingMetricsConfigNew: Record<string, OrderEditingMetric> = {
  impressions: {
    label: 'Impressions',
    value: 0,
    suffix: '',
    prefix: '',
  },
  editsCompleted: {
    label: 'Edits Completed',
    value: 0,
    suffix: '',
    prefix: '',
  },
  editRevenue: {
    label: 'Edit Revenue',
    value: 0,
    suffix: '',
    prefix: '$',
  },
  editEngagementRate: {
    label: 'Edit Engagement rate',
    value: 0,
    suffix: '%',
    prefix: '',
  },
  netRevenue: {
    label: 'Net Revenue',
    value: 0,
    suffix: '',
    prefix: '$',
  },
};

export const getOrderEditingMetricsConfig = (useNewMetrics: boolean): Record<string, OrderEditingMetric> => {
  return useNewMetrics ? { ...OrderEditingMetricsConfigNew } : { ...OrderEditingMetricsConfigOld };
};
export interface OrderEditingMetric {
  label: string;
  value: string | number;
  suffix: string;
  prefix: string;
}

export type OrderEditMetricsDto = {
  editsCompleted: number;
  impressions: number;
  // Old metrics
  netRevenueChange?: number;
  // New metrics
  editRevenue?: number;
  netRevenue?: number;
};
